/**
 * User: daletan
 * Date: 12/22/14
 * Time: 7:30 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var Backbone = require('dibs-backbone');
var headerStr = 'YOUR RECENT HISTORY';

module.exports = Backbone.BaseView.extend({
    className: 'recent-history-title',
    render: function() {
        this.$el.html(headerStr);
        return this;
    },
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/recentHistory/RecentHistoryTitleView.js
// module id = 575
// module chunks = 7 8 9 10 11 21